import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  z-index: 10;

  .ant-layout-header {
    padding: 0 16px;

    @media (min-width: 1025px) {
      padding: 0 24px;
    }
  }

  .hdr-inner {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    column-gap: 12px;
    padding: 0 12px;
    height: 64px;
  }

  .left {
    display: flex;
    align-items: center;
    gap: 12px;

    .back {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      color: #6c757d;
    }
  }

  .center {
    display: flex;
    justify-content: center;
    min-width: 0; /* evita overflow */
    .title {
      margin: 0;
      color: #6c757d;
      font-weight: 400;
      font-size: 18px;
      line-height: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .right {
    width: 36px;
    height: 36px;
  } /* balanceia com a seta da esquerda */

  @media (min-width: 768px) {
    .hdr-inner {
      padding: 0 16px;
    }
    .center .title {
      font-size: 20px;
    }
    .left .logo .extra {
      display: inline;
    } /* mostra logos extras em telas maiores */
  }
`;

export const StyledNavLink = styled.div<{ active?: string }>`
  display: inline;
  padding: 0.5em;
  margin: 0 1em;
  border-bottom: 2px solid transparent;
  color: ${({ active }) => (active ? '#015989;' : 'rgba(0,0,0,0.7);')};
  cursor: pointer;
  transition: color 0.3s linear, opacity 0.3s linear;

  &:hover {
    opacity: 0.8;
    color: #015989;
  }
`;

export const LogoWrapper = styled.div`
  float: left;
`;

export const IntelbrasLogoWrapper = styled.div`
  float: left;
  height: 100%;
  a {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    position: relative;
    color: #029436;
    cursor: inherit;
  }
  img {
    position: relative;
    top: 3px;
  }
  span {
    position: relative;
    left: 130px;
    width: 52px;
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
  }
`;
